import React from "react";

// Custom institutional crest for the International Securities & Exchange
// Commission of Sierra Leone (ISEC). Pure SVG, no external assets.
export default function Logo({ size = 46, light = false }) {
  const navy = light ? "#ffffff" : "#0b2d52";
  const green = "#137a47";
  const gold = "#c4992a";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="ISEC Sierra Leone crest"
    >
      <path
        d="M50 4 L90 16 V46 C90 72 72 90 50 96 C28 90 10 72 10 46 V16 Z"
        fill={navy}
        stroke={gold}
        strokeWidth="3"
      />
      <path d="M22 30 H78 V40 H22 Z" fill={green} />
      <rect x="32" y="46" width="6" height="24" fill={gold} />
      <rect x="47" y="40" width="6" height="30" fill={gold} />
      <rect x="62" y="52" width="6" height="18" fill={gold} />
      <path d="M22 72 H78" stroke={gold} strokeWidth="3" strokeLinecap="round" />
      <polygon points="50,12 52.4,18.6 59.4,18.6 53.8,22.8 55.9,29.4 50,25.3 44.1,29.4 46.2,22.8 40.6,18.6 47.6,18.6" fill={gold} />
    </svg>
  );
}
